import { isObject } from '../../../predicates/type';
import { IS_DEVELOPMENT, IS_LOCAL_DEVELOPMENT } from '../../../const/env';
import { notificationErrorMessageHandler, shouldHandleErrorStatusCode } from './network';
import isPlainObject from 'lodash/isPlainObject';
import { parseValidation } from '../../../utils/validationParser';
import { CustomObject } from '../../../types';
import { FormErrors, SubmissionError } from 'redux-form';
import { NetworkError } from '@packages/dataFetch';

const parseNumberFromString = (value: string) => Number(value.replace(',', '.'));
const isSerializedFloatWithComma = (value: string) => {
	const hasComma = value.indexOf(',') !== -1;

	return hasComma && !Number.isNaN(parseNumberFromString(value));
};
export const detectSerializedFloatsWithComma = <T extends Record<string, unknown>>(data: T) => {
	Object.entries(data).forEach((value) => {
		if (isObject(value)) {
			detectSerializedFloatsWithComma(value);

			return;
		}

		if (typeof value === 'string' && isSerializedFloatWithComma(value)) {
			const warningMessage =
				'Stringified float with comma has been detected! ' +
				'Consider converting it to a number before sending to the server! ' +
				'Found value: ' +
				value;

			if (IS_LOCAL_DEVELOPMENT) {
				alert(warningMessage);
			}

			if (IS_DEVELOPMENT) {
				console.warn(warningMessage);
			}
		}
	});
};

function tryParseValidation(validation: unknown) {
	if (typeof validation !== 'undefined' && isPlainObject(validation)) {
		const parsedValidation = parseValidation(validation as CustomObject);

		if (Object.keys(parsedValidation).length === 0) {
			return;
		}

		throw new SubmissionError(parsedValidation as FormErrors);
	}
}

export function catchErrorResponse(error: NetworkError) {
	const status = error?.response?.status;

	if (shouldHandleErrorStatusCode(status)) {
		notificationErrorMessageHandler(error);
	}

	const data = error?.response?.data;

	//IMPORTANT, would be great to handle async form validation with status code 400
	//try to throw form SubmissionError, but first ensure data is object only
	tryParseValidation(data);

	//try to parse error prop as validation object
	tryParseValidation(error);
}

export function catchErrorResponseWithoutNotification(error: NetworkError) {
	const data = error?.response?.data;

	//IMPORTANT, would be great to handle async form validation with status code 400
	//try to throw form SubmissionError, but first ensure data is object only
	tryParseValidation(data);

	//try to parse error prop as validation object
	tryParseValidation(error);
}
